import type { PatientNavigatorItemData } from './types';

export type PatientFilterTab = 'urgent' | 'routine';

export interface PatientQueueCounts {
  total: number;
  urgent: number;
  routine: number;
  inProgress: number;
}

export const PATIENT_FILTER_TABS: { id: PatientFilterTab; label: string }[] = [
  { id: 'urgent', label: 'Urgent' },
  { id: 'routine', label: 'Routine' },
];

export function computePatientQueueCounts(
  patients: PatientNavigatorItemData[]
): PatientQueueCounts {
  let total = 0;
  let urgent = 0;
  let routine = 0;
  let inProgress = 0;

  for (const patient of patients) {
    const hasOpenRequest = patient.urgentCount > 0 || patient.routineCount > 0;
    if (!hasOpenRequest) {
      continue;
    }

    total += 1;
    if (patient.urgentCount > 0) {
      urgent += 1;
    }
    if (patient.routineCount > 0) {
      routine += 1;
    }
    if (patient.viewerCount > 0) {
      inProgress += 1;
    }
  }

  return { total, urgent, routine, inProgress };
}

export function filterPatientsByTab(
  patients: PatientNavigatorItemData[],
  tab: PatientFilterTab
): PatientNavigatorItemData[] {
  switch (tab) {
    case 'urgent':
      return patients.filter((p) => p.urgentCount > 0);
    case 'routine':
      return patients.filter((p) => p.routineCount > 0);
    default: {
      const _exhaustive: never = tab;
      void _exhaustive;
      return patients;
    }
  }
}
